import { useAuth as authContext, hasAuthParams } from "react-oidc-context";
import { useTokenRenewalContext } from "../TokenRenewalContext/TokenRenewalContext";
import { UserAuthState } from "shared/core/state/userAuthState";
import { authenticateMobileUser } from "core/javascriptChannels";
import { UseAuthResultV1 } from "core/auth/model";
import { ClientInfoState } from "shared/core/state/clientInfoState";
import { appInsightsLogger } from "core/monitoring/AppInsights";

let addedAuthEvents = false;

export const useAuth = (): UseAuthResultV1 => {
  const { signinRedirect, signoutRedirect, signinSilent, isAuthenticated, isLoading, events, removeUser } = authContext();
  const shouldAuthenticate = !hasAuthParams() && !isAuthenticated && !isLoading;
  const { renewToken } = useTokenRenewalContext();
  const isMobileApp = !!window.flutter_inappwebview;

  // need to know what state addAuthEvents is in - does it need adding if already added in session? If the event listener keeps on getting added, we may need to use useRef to keep track if it has been added more than once;
  if (!addedAuthEvents) {
    events.addAccessTokenExpired((_) => {
      renewToken();
    });

    events.addSilentRenewError((err) => {
      appInsightsLogger.error("Error on silent renew. Removing user to force re-login.", err);
      removeUser();
    });

    events.addUserLoaded((_) => {
      const userInStorage = UserAuthState.get();
      const clientCode = ClientInfoState.getCode();

      if (isMobileApp && userInStorage && clientCode) {
        authenticateMobileUser(clientCode, userInStorage?.toStorageString());
      }
    });

    addedAuthEvents = true;
  }

  return {
    signinRedirect,
    signoutRedirect,
    signinSilent,
    isAuthenticated,
    shouldAuthenticate,
    isLoading,
  };
};
